<template>
  <tr>
    <td class="ac">{{ item.orderNo }}</td>
    <td class="ac">{{ item.sapOrderNo }}</td>
    <td class="ac">{{ item.erdDat }}</td>
    <td class="ac">{{ item.ztransDate }}</td>
    <td class="ac">
      <span
        v-show="item.statNm"
        class="c-util-button type-line-primary type-small type-round"
      >
        <span class="bold">{{ item.statNm }}</span>
      </span>
    </td>
    <td>{{ item.posnr }}</td>
    <td class="ar">{{ Number(item.goodsPrc).toLocaleString() }}원</td>

    <td class="ac">{{ item.dlvMthdNm }}</td>

    <td class="ac">
      <template
        v-if="
          item.dlvMthdCd == 10 ||
          item.dlvMthdCd == 15 ||
          item.dlvMthdCd == 18 ||
          item.dlvMthdCd == 25
        "
      >
        {{ item.addr }}
      </template>
      <template v-if="item.dlvMthdCd == 20">
        {{ item.dlvBranchCd }}
      </template>
      <template v-if="item.dlvMthdCd == 30">
        {{ Utils.replace(item.werks, "노루페인트", "") }}
      </template>
    </td>

    <td class="ac">{{ item.bname }}</td>

    <td class="ac">
      <div>
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          style="--btn-width: 78px"
          @click="emit('detail', item)"
        >
          <span>주문상세</span>
        </button>
        <!-- <button
          v-if="item.statCd == '0'"
          type="button"
          class="c-util-button type-primary type-small"
          style="--btn-width: 78px"
          @click="emit('cancel', item)"
        >
          <span>주문취소</span>
        </button> -->
        <button
          type="button"
          class="c-util-button type-primary type-small"
          style="--btn-width: 78px"
          @click="emit('reOrder', item)"
        >
          <span>다시주문</span>
        </button>
      </div>
    </td>
  </tr>
</template>
<script setup>
import { defineProps, ref, defineEmits } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const emit = defineEmits(["detail", "cancel", "reOrder"]);

const item = ref(props.item);
</script>
